"use strict";

require("core-js/modules/es6.object.define-property");

var _styledComponents = _interopRequireDefault(require("styled-components"));

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.BadgeWrapper = exports.SelectSuggestion = exports.DropdownRelationshipsWrapper = exports.SuggestionsWrapper = void 0;

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    "default": a
  };
}

var SuggestionsWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__SuggestionsWrapper"
})(["border:0.5px solid #e5e5e5;", ";", ";"], function (a) {
  return a.items && 1 < a.items && 4 >= a.item && "height: ".concat(2 * a.items, "rem;");
}, function (a) {
  return a.items && 4 < a.items && "height: 6rem;\n    overflow-y: scroll;";
});

exports.SuggestionsWrapper = SuggestionsWrapper;

var DropdownRelationshipsWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__DropdownRelationshipsWrapper"
})(["position:absolute;top:0;height:2.5rem;display:flex;align-items:center;right:0;"]);

exports.DropdownRelationshipsWrapper = DropdownRelationshipsWrapper;

var SelectSuggestion = _styledComponents["default"].div.withConfig({
  displayName: "styles__SelectSuggestion"
})(["position:relative;"]);

exports.SelectSuggestion = SelectSuggestion;

var BadgeWrapper = _styledComponents["default"].span.withConfig({
  displayName: "styles__BadgeWrapper"
})(["margin-left:0.5rem;color:white;"]);

exports.BadgeWrapper = BadgeWrapper;